import { DataService } from "@/services/data";
import { RouteObject } from "react-router-dom";

const CalendarRoute: RouteObject = {
    path: "calendar",
    async lazy() {
        let { CalendarPage } = await import("@/components/layout-2/calendar");
        return { Component: CalendarPage };
    },
    loader: async ({ request }) => {
        const { DEFAULT_DATE_RANGE } = await import("@/components/layout-2/calendar");
        const url = new URL(request.url);
        url.searchParams.set("date__range", url.searchParams.get("date__range") || DEFAULT_DATE_RANGE);
        const owner_id = url.searchParams.get("owner_id") || "self";
        url.searchParams.set("owner_id", owner_id);
        url.searchParams.set("page_size", url.searchParams.get("page_size") || "1000");

        // Ne rien afficher si aucun agent n'est sélectionné (éviter requête lourde)
        if (!owner_id || owner_id === "") {
            return { calendarItems: [] };
        }

        // Préparer les searchParams pour chaque endpoint
        const tasksSearchParams = new URLSearchParams(url.searchParams.toString());
        // Pour les tâches, on utilise created_by_id au lieu d'owner_id
        if (tasksSearchParams.has("owner_id")) {
            const ownerId = tasksSearchParams.get("owner_id");
            tasksSearchParams.delete("owner_id");
            tasksSearchParams.set("created_by_id", ownerId!);
        }

        const eventsSearchParams = new URLSearchParams(url.searchParams.toString());
        // Pour les événements SF, on utilise maintenant owner_id directement (backend corrigé)

        // Récupérer les données en parallèle
        const [eventsResp] = await Promise.all([
            DataService.client
                .url(`/crm/objects/events/${eventsSearchParams.toString() ? "?" + eventsSearchParams.toString() : ""}`)
                .get()
                .json()
                .catch(() => ({ results: [] }))
        ]);

        const events = eventsResp as { results: any[] };

        // Normalisation
        const calendarItems = [];

        for (const e of events.results) {
            const [date, time] = e.start_datetime ? e.start_datetime.split("T") : [null, null];
            calendarItems.push({
                id: `event_${e.id}`,
                type: "event",
                date,
                time: time ? time.slice(0, 5) : null,
                title: e.subject || "(Sans titre)",
                allow_edit: e.crm_allow_edit || false,
                raw: e
            });
        }

        return { calendarItems };
    },
    children: [
        {
            path: "agents",
            loader: async () => {
                try {
                    const { DataService } = await import("@/services/data");
                    return await DataService.client.url("/crm/objects/users/agents").get().json();
                } catch (error) {
                    console.error(error);
                    return [];
                }
            }
        }
    ]
};

export default CalendarRoute;
